import { gql } from '../../__gql__/gql';

export const PARTNER_CONFIGS = gql(`
  query PartnerConfigs($domain: String) {
    partnerConfigs(domain: $domain) {
      id
      name
      partnerId
      customPrefixUrl
      applicationSettings
      styling {
        backgroundColor
        backgroundContrastColor
        primaryColor
        primaryContrastColor
        secondaryColor
        secondaryContrastColor
        tertiaryColor
        tertiaryContrastColor
        logoUrl
        heroImageUrl
      }
      settings {
        showHubFirst
      }
      stylingOverrides {
        code
        value
      }
      tagManagers
      primaryUrl
      onlineBookingToolEnabled
      environmentConfigs {
        googleMapsApiKey
        adyenClientKey
        adyenMerchant
        environment
        sentryDSN
      }
    }
  }
`);
